export var I18N_EVENT;
(function (I18N_EVENT) {
    I18N_EVENT["GET_TEXT"] = "i18n.getText";
})(I18N_EVENT || (I18N_EVENT = {}));
